// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"sV-z","categoryName":"tV-z","categoryNameSearchHeader":"uV-z","categoryContent":"vV-z","bottomAligned":"wV-z","image":"xV-z","imageNoBackground":"yV-z"};